<template>
  <div class="yhgl">
    <div class="thrkBody">
      <div class="bodyHeader">
        <el-form
          ref="search"
          label-width="90px"
          :model="formInline"
          label-position="left"
          style="width: 90%; margin: 0 auto; display: flex; flex-wrap: wrap"
        >
          <el-form-item label="部门名称:">
            <el-input
              v-model="formInline.deptName"
              placeholder="请输入部门名称"
            />
          </el-form-item>
          <el-form-item label="部门状态:">
            <el-select v-model="formInline.status" placeholder="请选择部门状态">
              <el-option
                v-for="(item, index) in statusList"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <div>
            <el-button
              icon="el-icon-refresh-left"
              style="width: 80px; height: 39px"
              size="small"
              type="primary"
              round
              @click="resetDataSource"
            >重置</el-button>
            <!-- <el-button
              icon="el-icon-search"
              style="width: 80px; height: 39px"
              size="small"
              type="primary"
              round
              @click="loadDataSource"
              >搜索</el-button
            > -->
          </div>
        </el-form>
      </div>
      <div class="mainBody">
        <div class="bodyLeft">
          <!-- 左侧分级 -->
          <el-tree
            :data="leftOrgData"
            :props="defaultProps"
            :expand-on-click-node="false"
            :default-expand-all="true"
            @node-click="changeOrg"
          />
        </div>
        <div class="thrkRight">
          <div class="bodyTable">
            <div class="thrkLeft2">
              <div
                style="
                  width: 100%;
                  margin: 0 auto;
                  padding: 12px 10px;
                  background-color: #f3f5fa;
                "
              >
                <el-button
                  icon="el-icon-plus"
                  size="mini"
                  type="primary"
                  @click="addItem"
                >新增</el-button>
              </div>
              <el-table
                ref="table"
                :data="treeTable"
                border
                :expand-row-keys="expandRow"
                row-key="deptId"
                :header-cell-style="{ background: '#F3F5FA' }"
                :tree-props="{
                  children: 'children',
                  hasChildren: 'hasChildren',
                }"
                style="width: 100%"
              >
                <el-table-column
                  prop="deptName"
                  label="部门名称"
                  :show-overflow-tooltip="true"
                  align="center"
                />
                <el-table-column
                  prop="areaName"
                  label="行政区划名称"
                  :show-overflow-tooltip="true"
                  align="center"
                />
                <el-table-column
                  prop="deptCode"
                  label="部门编号"
                  :show-overflow-tooltip="true"
                  align="center"
                />
                <el-table-column
                  prop="tyshxydm"
                  label="统一社会信用代码"
                  :show-overflow-tooltip="true"
                  align="center"
                />
                <el-table-column
                  prop="orderNum"
                  label="排序"
                  :show-overflow-tooltip="true"
                  align="center"
                />
                <el-table-column label="状态" align="center">
                  <template slot-scope="scope">
                    <span>{{ scope.row.status == "0" ? "启用" : "停用" }}</span>
                    <!--   <el-switch
                    v-model="scope.row.status"
                    active-value="0"
                    inactive-value="1"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                  ></el-switch> -->
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="300px">
                  <template slot-scope="scope">
                    <el-button
                      v-preventReClick
                      type="primary"
                      size="mini"
                      round
                      style="
                        color: #409eff;
                        border-color: #409eff;
                        border-radius: 30px;
                        background-color: rgb(230, 242, 252);
                      "
                      @click="editItem(scope.row)"
                    >编辑</el-button>
                    <el-button
                      v-preventReClick
                      type="primary"
                      size="mini"
                      round
                      style="
                        color: #409eff;
                        border-color: #409eff;
                        border-radius: 30px;
                        background-color: rgb(230, 242, 252);
                      "
                      @click="lookItem(scope.row)"
                    >查看</el-button>
                    <el-button
                      v-preventReClick
                      type="primary"
                      size="mini"
                      round
                      style="
                        color: #409eff;
                        border-color: #409eff;
                        border-radius: 30px;
                        background-color: rgb(230, 242, 252);
                      "
                      @click="deleteItem(scope.row)"
                    >删除</el-button>
                    <el-button
                      v-preventReClick
                      type="primary"
                      size="mini"
                      round
                      style="
                        color: #409eff;
                        border-color: #409eff;
                        border-radius: 30px;
                        background-color: rgb(230, 242, 252);
                      "
                      @click="uploadSign(scope.row)"
                    >上传签章</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 上传 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="上传签章"
      :visible.sync="upwindow"
      width="30%"
      center
      @close="closeDialog"
    >
      <div class="myUpload" style="text-align: center">
        <el-upload
          :action="returnSaveFile"
          list-type="picture-card"
          :limit="1"
          :on-preview="handlePictureCardPreview"
          :before-upload="beforeUpload"
          :headers="token"
          :class="{ disabled: showUpload }"
          :on-success="handleSuccess"
          :file-list="fileList"
          :on-remove="handleRemove"
        >
          <i class="el-icon-plus" />
        </el-upload>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button v-preventReClick @click="closeDialog">取 消</el-button>
        <el-button
          v-preventReClick
          type="primary"
          @click="upfile"
        >上传</el-button>
      </span>
    </el-dialog>
    <BmglTk ref="BmglTk" />
  </div>
</template>
<script>
import { getManageTree, deleteDept, upLoadSign } from '@/assets/js/bmgl.js'
import { returnShowPic, returnSaveFile, getToken } from '@/assets/js/common.js'
import BmglTk from '../components/Bmgl/BmglTk.vue'
export default {
  name: 'Bmgl',
  components: { BmglTk },
  data() {
    return {
      allOrgs: [],
      defaultProps: {
        children: 'items',
        label: 'label'
      },
      statusList: [
        // 状态列表
        {
          label: '正常',
          value: '0'
        },
        {
          label: '停用',
          value: '1'
        }
      ],
      token: {
        Authorization: getToken()
      },
      upwindow: false, // 上传dialog开关
      showUpload: false, // 控制上传按钮的样式
      tableData: [],
      fileList: [], // 文件列表
      returnSaveFile: '',
      expandRow: [],
      formInline: {
        user: '',
        region: '',
        date1: '',
        date2: ''
      }
    }
  },
  computed: {
    treeTable: function() {
      var searchValue = this.formInline.deptName
      if (searchValue) {
        const treeData = this.tableData
        const handleTreeData = this.handleTreeData(treeData, searchValue)
        this.setExpandRow(handleTreeData)
        this.expandRow = this.expandRow.join(',').split(',')
        return handleTreeData
      } else {
        // this.toggleRowExpansionAll(this.tableData, false);
        return this.tableData
      }
    },
    leftOrgData() {
      var searchValue = this.formInline.deptName
      if (searchValue) {
        const treeData = this.allOrgs
        let handleTreeData = this.handleTreeData(treeData, searchValue)
        handleTreeData = handleTreeData.map(d => {
          if (d.children) {
            d.items = d.children.map(j => {
              j.label = j.areaName
              return j
            })
          }
          d.label = d.deptName
          return d
        })
        if (handleTreeData.length > 0) {
          if (handleTreeData[0].children && handleTreeData[0].children.length > 0) {
            this.changeOrg(handleTreeData[0].children[0])
          } else {
            this.changeOrg(handleTreeData[0])
          }
        }
        return handleTreeData
      } else {
        return this.allOrgs
      }
    }
  },
  watch: {},
  created() { },
  mounted() {
    this.returnSaveFile = returnSaveFile()
    this.loadDataSource()
  },
  beforeDestroy() { },
  methods: {
    changeOrg(data) {
      // 选择机构
      if (data.xzqhId === 0) {
        // 一级不显示子节点
        data = Object.assign({}, data)
        delete data.children
      }
      this.tableData = [data]
      // 展开所有的
      this.expandRow = [data.deptId]
    },
    toggleRowExpansionAll(data, isExpansion) {
      data.forEach((item) => {
        this.$refs.table.toggleRowExpansion(item, isExpansion)
        if (item.children !== undefined && item.children !== null) {
          this.toggleRowExpansionAll(item.children, isExpansion)
        }
      })
    },
    handleTreeData(treeData, searchValue) {
      if (!treeData || treeData.length === 0) {
        return []
      }
      const array = []
      for (let i = 0; i < treeData.length; i += 1) {
        let match = false
        for (const pro in treeData[i]) {
          if (typeof treeData[i][pro] === 'string') {
            match |= treeData[i][pro].includes(searchValue)
            if (match) break
          }
        }
        if (
          this.handleTreeData(treeData[i].children, searchValue).length > 0 ||
          match
        ) {
          array.push({
            ...treeData[i],
            children: this.handleTreeData(treeData[i].children, searchValue)
          })
        }
      }
      return array
    },
    // 将过滤好的树形数据展开
    setExpandRow(handleTreeData) {
      if (handleTreeData.length) {
        for (const i of handleTreeData) {
          this.expandRow.push(i.deptId)
          if (i.children.length) {
            this.setExpandRow(i.children)
          }
        }
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.imgVisible = true
    },
    // 限制图片格式
    beforeUpload(file) {
      const fileType = ['image/jpeg', 'image/png', 'image/bmp']
      const isLt2M = file.size / 1024 < 500
      const typeTrue = fileType.includes(file.type)
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 500k!')
      }
      if (!typeTrue) {
        this.$message.error('上传图片只能是 JPG/BMP/JPEG/PNG格式!')
      }
      return typeTrue && isLt2M
    },
    // 移除图片时将修改样式
    handleRemove(file, fileList) {
      if (fileList.length == 0) {
        this.showUpload = false
      }
    },
    // 获取文件地址 限制上传一张
    handleSuccess(response, file, fileList) {
      this.wjdz = response.data.url
      if (fileList.length == 1) {
        this.showUpload = true
      }
    },
    // 关闭dialog 并清空文件列表
    closeDialog() {
      this.showUpload = false
      this.upwindow = false
      this.fileList = []
      this.wjdz = ''
    },
    // 确定上传
    upfile() {
      if (this.wjdz) {
        upLoadSign({
          deptId: this.activeRow.deptId,
          sign: this.wjdz
        }).then((e) => {
          if (e.data.code == '000000') {
            this.$message.success('上传签章成功!')
            this.closeDialog()
          }
        })
      }
    },
    // 上传签章
    uploadSign(row) {
      this.upwindow = true
      this.activeRow = row
    },
    // 重置
    resetDataSource() {
      this.formInline = {}
    },
    loadDataSource() {
      getManageTree().then((e) => {
        // this.tableData = e.data.data;
        // console.log(e)
        if (e.status === 200 && e.data.code === '000000') {
          this.allOrgs = e.data.data.map(d => {
            if (d.children) {
              d.items = d.children.map(j => {
                j.label = j.areaName
                return j
              })
            }
            d.label = d.deptName
            return d
          })
          this.changeOrg(this.allOrgs[0])
        }
      })
    },
    // 添加
    addItem() {
      this.$refs.BmglTk.dialogVisible = true
      this.$refs.BmglTk.todoType = 'add'
    },
    // 删除
    deleteItem(row) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteDept(row.deptId).then((e) => {
            if (e.data.code == '000000') {
              this.$message({
                type: 'success',
                message: '删除成功'
              })
              this.loadDataSource()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 编辑
    editItem(row) {
      this.$refs.BmglTk.dialogVisible = true
      this.$refs.BmglTk.jbxxForm = Object.assign({}, row)
      this.$refs.BmglTk.fileList = [
        {
          url: returnShowPic() + row.sign
        }
      ]
      this.$refs.BmglTk.todoType = 'edit'
    },
    lookItem(row) {
      this.$refs.BmglTk.dialogVisible = true
      this.$refs.BmglTk.jbxxForm = Object.assign({}, row)
      this.$refs.BmglTk.fileList = [
        {
          url: returnShowPic() + row.sign
        }
      ]
      this.$refs.BmglTk.todoType = 'look'
    }
  }
}
</script>
<style scoped lang='less'>
.yhgl {
  .thrkBody {
    margin: 0 auto;
    .bodyHeader {
      width: 95%;
      background-color: #fff;
      margin: 0 auto;
      margin-bottom: 11px;
      margin-top: 30px;
      display: flex;
      align-items: center;
      padding: 30px 0 0 0;
      border-radius: 5px;
      .el-form-item {
        width: 22%;
        margin-right: 10px;
        &:nth-child(4) {
          margin-right: 0px;
        }
        &:nth-child(5) {
          width: 50%;
          .el-date-editor {
            width: 40%;
          }
        }
        .el-form-item__content {
          display: flex;
        }
      }

      .el-button--primary {
        color: #fff;
        background: #4170ff;
        border-color: #4170ff;
        width: 90px;
        height: 39px;
      }
    }
    .mainBody {
      width: 95%;
      display: flex;
      flex-direction: row;
      margin: 0 auto;
      .bodyLeft {
        width: 250px;
        background-color: #fff;
        height: 100%;
        padding: 40px 20px;
      }
    }
    .thrkRight {
      margin-left: 10px;
      width: calc(95% - 200px);
      background-color: #fff;
      padding-top: 40px;
      padding-bottom: 57px;
      .bodyTable {
        width: 90%;
        margin: 0 auto;
        display: flex;
        .thrkLeft1 {
          width: 200px;
          margin-right: 15px;
        }
        .thrkLeft2 {
          width: 100%;
          .addmessheader {
            background: #f4f4f4;
            .addmess {
              margin: 12px 0 12px 8px;
            }
          }
          .el-button--primary {
            color: #fff;
            background: #4170ff;
            border-radius: 3px;
            border-color: #4170ff;
          }
        }
      }
      .el-pagination__total {
        margin-left: 8px;
      }
      .el-pagination {
        padding: 10px 0;

        border: 1px solid #ebeef5;
        border-top: 0;
      }
      .el-pager {
        .number {
          background: #4170ff;
          border-color: #4170ff;
        }
      }
    }
  }
  /deep/ .disabled .el-upload--picture-card {
    display: none;
  }
}
/deep/.el-dialog__header {
  .header-title {
    text-align: left;
  }
}
/deep/.el-dialog__body {
  padding: 0;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4170ff !important;
  color: #fff;
}
</style>
